
import Dashboard  from './Dashboard';

export default Dashboard


// WEBPACK FOOTER //
// ./src/app/views/merchant/dashboard/index.js